import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow: string;
  title: ReactNode;
  description?: string;
  align?: "left" | "center";
  tone?: "light" | "dark";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  tone = "light",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`reveal max-w-2xl ${isCenter ? "mx-auto text-center" : "text-left"}`}
    >
      <span
        className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium uppercase tracking-[0.16em] ${
          tone === "dark"
            ? "bg-background-50/10 text-primary-200"
            : "bg-primary-100 text-primary-700"
        }`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
        {eyebrow}
      </span>
      <h2
        className={`mt-4 font-heading text-3xl font-semibold leading-tight md:text-4xl lg:text-[2.75rem] ${
          tone === "dark" ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-4 text-base leading-relaxed md:text-lg ${
            tone === "dark" ? "text-background-200" : "text-foreground-600"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}